/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum InvestitionBuildingType {
    Neubau = 'Neubau',
    Umbau = 'Umbau',
    Sanierung = 'Sanierung'
  }

    export const InvestitionBuildingTypeTranslocoMap: Record<InvestitionBuildingType, string> = {
    [InvestitionBuildingType.Neubau]: 'investitionBuildingType.neubau',
    [InvestitionBuildingType.Umbau]: 'investitionBuildingType.umbau',
    [InvestitionBuildingType.Sanierung]: 'investitionBuildingType.sanierung',
    };

    export const InvestitionBuildingTypeOptions = [
  { value: InvestitionBuildingType.Neubau, labelKey: 'investitionBuildingType.neubau' },
  { value: InvestitionBuildingType.Umbau, labelKey: 'investitionBuildingType.umbau' },
  { value: InvestitionBuildingType.Sanierung, labelKey: 'investitionBuildingType.sanierung' },
    ];

